// extracted by mini-css-extract-plugin
export default {"fullScreenTextContainer":"FullScreenButton_fullScreenTextContainer__MbLHh","fullScreenText":"FullScreenButton_fullScreenText__HeBHG","disabled":"FullScreenButton_disabled__1ENJG"};